// extracted by mini-css-extract-plugin
module.exports = {"loader":"Imprint_loader__1WE3d","root":"Imprint_root__FUQTJ","lastUpdated":"Imprint_lastUpdated__bBBuP","heading":"Imprint_heading__N60lb"};